export type EventHandler<E> = (event: E, ...args: any[]) => void;

export class MessageBus<E> {
  private events: Map<E, EventHandler<E>[]> = new Map();

  subscribe(event: E, handler: EventHandler<E>): void {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }
    this.events.get(event)!.push(handler);
  }

  unsubscribe(event: E, handler: EventHandler<E>): void {
    if (this.events.has(event)) {
      this.events.set(
        event,
        this.events.get(event)!.filter((h) => h !== handler)
      );
    }
  }

  publish(event: E, ...args: any[]): void {
    if (this.events.has(event)) {
      this.events.get(event)!.forEach((handler) => handler(event, ...args));
    }
  }
}